import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RootState } from '../../../store';
import { useSelector } from 'react-redux';

export interface UnauthorizedProps { }


type Props = UnauthorizedProps & RouteComponentProps


const Unauthorized: React.FunctionComponent<Props> = props => {
    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const goHome = () => {
        props.history.push({ pathname: `/${currentAoo?.id}/ricerca` });
    }

    return (
        <div className="error-page">
            <div className="error-code-container">
                <FontAwesomeIcon className="error-icon" icon={{ prefix: 'fal', iconName: 'lock-alt' }} />
                <h1 className="error-code">403</h1>
            </div>
            <h2 className="error-description">Non si è autorizzati ad accedere a questa risorsa</h2>
            <a onClick={goHome} className="error-page-button">Home</a>
        </div >
    );

}
export default withRouter(Unauthorized);